import { Alert } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { useUserState } from 'providers/user-state-provider';

/**
 * App-wide notice shown to read-only processor accounts so it's clear why write
 * actions are unavailable. The API is the enforcement point; this is UX context.
 */
export function ReadOnlyBanner() {
  const { isReadOnlyProcessor } = useUserState();

  if (!isReadOnlyProcessor) return null;

  return (
    <Alert
      severity="info"
      icon={<VisibilityOutlinedIcon fontSize="inherit" />}
      sx={{ borderRadius: 0, justifyContent: 'center' }}
    >
      You have read-only access. You can view data but cannot make changes.
    </Alert>
  );
}
